<template>
  <div>
    <Modal type="modal-sm" v-if="showModal">
      <div class="text-center">
        <IconCloseCircle height="50" :class="{
          [confirm.iconClass]: true,
          'mb-3': true
        }" />
        <p class="font-weight-normal mb-3">{{confirm.text}}</p>
        <div>
          <button :class="{
            'btn': true,
            [confirm.buttonClass]: true
          }" @click="submit">{{confirm.buttonText}}</button>
          <button class="btn btn-link ml-2" @click="showModal = false">Cancel</button>
        </div>
      </div>
    </Modal>

    <button type="button" :class="{
      btn: true,
      [buttonClass]: true
    }" @click="submit" v-if="showButton" :disabled="loading">
      <span v-if="loading">{{submittingText}}</span>
      <span v-else>{{submitText}}</span>
    </button>

    <Alert class="alert-danger mb-0" title="Too many requests" v-if="tooManyRequests" icon="IconImportant">
      <p class="mb-0">Please wait for at least one hour before retrying the same request. You can try again after {{tooManyRequests}}.</p>
    </Alert>

    <Alert class="alert-success mb-0" title="Success" v-if="success" icon="IconCheck">
      <p class="mb-0">{{successText}} <span v-if="!noReflect">It may take up to 1 hour to reflect the updates.</span></p>
    </Alert>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Modal from '@/components/Modal'

export default {
  components: {
    Modal
  },
  props: {
    confirm: {
      type: Object,
      default: () => ({
        icon: null,
        iconClass: null,
        text: null,
        buttonText: null,
        buttonClass: null
      })
    },
    type: String,
    krakenShop: String,
    submitText: {
      type: String,
      default: 'Submit'
    },
    submittingText: {
      type: String,
      default: 'Submitting'
    },
    successText: {
      type: String,
      default: 'Your settings are being updated.'
    },
    buttonClass: {
      type: String,
      default: 'btn-primary'
    },
    noReflect: {
      type: Boolean
    }
  },
  data: function () {
    return {
      loading: false,
      showButton: true,
      tooManyRequests: false,
      success: false,
      showModal: false
    }
  },
  methods: {
    ...mapActions([ 'submitRequest' ]),
    submit: async function () {
      if (this.confirm.text) {
        if (this.showModal) {
          this.showModal = false
        } else {
          this.showModal = true
          return
        }
      }

      this.loading = true

      const res = await this.submitRequest({ type: this.type, krakenShop: this.krakenShop })

      if (res === true) {
        this.success = true
      } else {
        this.tooManyRequests = res
      }

      this.showButton = false
      this.loading = false
    }
  }
}
</script>
